import React from 'react';

const SocialProofStrip = () => {
  const companies = [
    'Company A', 'Company B', 'Company C', 'Company D', 
    'Company E', 'Company F', 'Company G', 'Company H'
  ];

  return (
    <section className="py-16 bg-[#0B1220]/50 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-white/60 text-sm uppercase tracking-wider mb-8">
          Trusted by future-forward teams
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-8 items-center justify-items-center">
          {companies?.map((company, index) => (
            <div
              key={index}
              className="w-full h-16 flex items-center justify-center opacity-40 hover:opacity-70 transition-opacity duration-300">
              <div className="text-white/50 text-xs font-semibold uppercase tracking-wider">
                {company}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofStrip;